import { postFileUpload } from "./helpers/http-handler";

export const mediaUpload = (payload: any) =>
  postFileUpload(`${process.env.REACT_APP_API_URL}/media-uploads/file/upload`, payload);
